
import React from "react";


import {Well,Label,Panel,Glyphicon,Button } from "react-bootstrap";
import {ActionsDisplay} from "./ActionsDisplay"



export const MacroDisplay = (props)=>{
  let d=props.data
  let macroindex=props.index
  //console.log("MACRO")
  //console.log(d)

  if(d==undefined){
    return(<span>No Macro<br/></span>)
  }

  if(d.name=="NI macro"){
    d.name="Automaticly generated Nurse Interface"
  }






  return(<Panel bsSize="small" >
          <Panel.Heading>
            <Panel.Title >
            {macroindex.length>=38 ?(<Button className="pull-right" bsSize="xsmall" onClick={()=>props.callback("delete",macroindex)}>
              <Glyphicon glyph="trash" /> Delete
            </Button>):("")}
            <Button className="pull-right" bsSize="xsmall" onClick={()=>props.callback("edit",macroindex)}>
              <Glyphicon glyph="pencil" /> Edit
            </Button>
              <Button className="pull-right" bsSize="xsmall" onClick={()=>props.callback("run",macroindex)}>
                <Glyphicon glyph="play" /> Run
              </Button>
            </Panel.Title>
            <Panel.Toggle componentClass="a">
            {d.interfaceOption==true ? (<span>✳&nbsp;</span>):(<span></span>)}
            {d.name} - {d.description}</Panel.Toggle>
          </Panel.Heading>
          <Panel.Body collapsible><ul>
            {d.actions.map((d,i) =><li key={i}><ActionsDisplay data={d} outputs={props.outputs} vars={props.vars} macros={props.macros} events={props.events} schedule={props.schedule}></ActionsDisplay></li>)}
      </ul>
      <Button className="pull-right" bsSize="xsmall" onClick={()=>props.callback("copy",macroindex)} >
        <Glyphicon glyph="copy" / > Copy
      </Button>


      </Panel.Body>
</Panel>)
}



// WEBPACK FOOTER //
// ./src/programmerComponents/MacroDisplay.js